import strings from "../core/translate";

// Turns an axios/nest error into one readable line for the form alert.
export const apiErrorMessage = (err) => {
  const message = err && err.response && err.response.data && err.response.data.message;
  if (Array.isArray(message)) return message.join(", ");
  if (message) return message;
  return (err && err.message) || strings.error;
};
